import type { ChangelogCategory } from "@/lib/types";

export const CATEGORY_LABELS: Record<ChangelogCategory, { label: string; cls: string }> = {
  new: { label: "Nouveauté", cls: "border-orange-500/40 bg-orange-500/10 text-orange-300" },
  improvement: { label: "Amélioration", cls: "border-cyan-500/40 bg-cyan-500/10 text-cyan-300" },
  fix: { label: "Correction", cls: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" },
};

export const SEEN_EVENT = "changelog:seen";
const seenKey = (userId: string) => `innova:changelog-seen:${userId}`;

export function getSeen(userId: string): string {
  return localStorage.getItem(seenKey(userId)) || "";
}

export function markSeen(userId: string, latest: string) {
  localStorage.setItem(seenKey(userId), latest);
  window.dispatchEvent(new Event(SEEN_EVENT));
}
